// for use in LobbyHeader

import React from "react";

import { allowFullscreen, IProps, toggleFullscreen } from ".";
import HeaderGameList from "../HeaderGameList";
import { footerButton } from "../DesktopGameFooter";

import dateTimeFormat from "@/modules/dateTimeFormat";
import { isTotoGame, totoGames } from "@/modules/gamePcode";
import { assetImg } from "@/modules/moduleImporter";

import img_streaming from "@/assets/img/img_streaming.png";
import img_header_hide from "@/assets/img/svg/buttons/header_hide.svg";
import img_header_open from "@/assets/img/svg/buttons/header_open.svg";

interface IState {
	showHeader: boolean,
	autoHideHeader: boolean,
	showHeaderGroup: boolean,
    headerGroupCode: string,
}

export default class InGameHeaderFragment extends React.Component<IProps, IState> {
	private timeoutHide: number;
	private showStreamingButton = false;

	constructor(props: IProps) {
		super(props);

		this.state = {
			showHeader: true,
			autoHideHeader: false,
			showHeaderGroup: false,
			headerGroupCode: ""
		};
	}
	
	/**
	 * Used in LobbyHeader
	 */
	 private closeHeaderGroup() {
		this.setState({ showHeaderGroup: false });
	}

	private toggleAutoHideHeader() {
		const { autoHideHeader } = this.state;

		this.setState({
			autoHideHeader: !autoHideHeader
		}, () => {
			this.props.setAutoHideHeader(!autoHideHeader);
		});
	}

	private toggleHeaderGroup(e: any): void {
		const game = e.currentTarget.getAttribute("groupgame");
	
		this.setState({
			headerGroupCode: game,
			showHeaderGroup: !this.state.showHeaderGroup,
		});
	}

	private showHeader() {
		this.setState({ showHeader: true });
	}

	/**
	 * Trigger hide header transition
	 */
	private hideHeader() {
		if (this.timeoutHide)
			window.clearTimeout(this.timeoutHide);

		if (this.state.autoHideHeader)
			this.timeoutHide = window.setTimeout(() => {
				this.setState({ showHeader: false });
			}, 1500);
	}

	private headerButton(tooltip: string, image: string, onClick: (e: React.SyntheticEvent<HTMLButtonElement>) => void, extraProps?: any) {
		return (
			<button className="tip" {...extraProps} onClick={onClick}>
				{assetImg("sidemenu", image, "", "sl-icon-header")}

				<span>
					{tooltip}
				</span>
			</button>
		);
	}

	private headerGameListFragment() {
		if (this.props.activeGameCount === 0)
			return null;

		// Note: don't use mutated games
		return (
			<HeaderGameList
				{...{...this.props, ...this.state}}

				closeHeaderGroup={this.closeHeaderGroup.bind(this)}
				toggleHeaderGroup={this.toggleHeaderGroup.bind(this)}
			/>
		);
	}

	private get classToto() {
		const { pcodeMax } = this.props;
		return totoGames.includes(pcodeMax) ? "v5" : "";
	}

	private dateTimeFragment() {
		const { userdata } = this.props;

		if (!userdata)
			return null;

		const { dateTime, lang } = userdata.user;

		return (
			<div className={this.classToto + " box-time-header"}>
				{dateTimeFormat(dateTime, lang)}
			</div>
		);
	}

	private streamingButtonFragment() {
		if (!this.showStreamingButton)
			return null;

		return (
			<div className="stream-control-header">
				<img
					className="stream-icon"
					src={img_streaming}
					alt="streaming icon" />

				<div>
					<div className="active">SD</div>
					<div>HD</div>
				</div>
			</div>
		);
	}
	
	private cornerFragment() {
		const
			{ classToto, headerButton } = this,
			{ closeAllGames, langdata, goToOperatorLobby } = this.props;

		return (
			<div className={classToto + " box-button-header"}>
				<div>
					{
						allowFullscreen()
							? headerButton(
								langdata["txt_full_screen"],
								"fullscreen.svg",
								toggleFullscreen.bind(this)
							) : null
					}

					{headerButton(
						langdata["txt_exit"],
						"logout.svg",
						goToOperatorLobby
					)}
				</div>
			</div>
		);
	}

	private autoHideButtonFragment() {
		return (
			<img className={"auto-hide-eye"}
				src={this.state.autoHideHeader ? img_header_open : img_header_hide}
				onClick={this.toggleAutoHideHeader.bind(this)}
				alt="auto hide" />
		);
	}

	private totoGameButtonsFragment() {
		const {
			langdata, pcodeMax,
			togglePopupTransactionHistory,
			togglePopupResultHistory,
			toggleHowToPlay
		} = this.props;

		if (!isTotoGame(pcodeMax))
			return null;

		return (
			<div className="v5-button-header">
				{footerButton(
					langdata["txt_transaction_history"],
					"transaction_history.svg",
					togglePopupTransactionHistory
				)}

				{footerButton(
					langdata["txt_result_history"],
					"result_history.svg",
					togglePopupResultHistory
				)}

				{footerButton(
					langdata["txt_how_to_play"],
					"how_to_play.svg",
					toggleHowToPlay,
					{ game: pcodeMax }
				)}
			</div>
		);
	}

	render() {
		const
			{ autoHideHeader, showHeader } = this.state,
			classNames = [
				"sl-header",
				"v3",
				(autoHideHeader ? " autohide" + (showHeader ? "" : " hidden") : "")
			].join(" ");

		return (
			<div
				className={classNames}
				onMouseMove={this.showHeader.bind(this)}
				onMouseOut={this.hideHeader.bind(this)}>

				{this.totoGameButtonsFragment()}

				{this.autoHideButtonFragment()}
				{/* {this.headerGameListFragment()} */}
				{this.dateTimeFragment()}
				{this.streamingButtonFragment()}
				{this.cornerFragment()}
			</div>
		);
	}
}
